import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useUserDeletion from '../../hooks/useUserDeletion';
import UserDataTable from './UserDataTable';
import Loader from './Loader';

const UserManagementWrapper = ({
  // Data fetching
  fetchFunction, // NOSONAR
  fetchArgs, // NOSONAR
  selector, // NOSONAR

  // Navigation
  detailRoute, // NOSONAR

  // Table configuration
  columns = [], // NOSONAR
  title = "", // NOSONAR

  // Props
  filteredData, // NOSONAR
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const data = useSelector(selector);

  // Create refresh function for the hook
  const refreshData = () => {
    if (fetchFunction && fetchArgs) {
      if (Array.isArray(fetchArgs)) {
        // Handle multiple fetch calls (like for attorney/fiduciary)
        Promise.all(fetchArgs.map(args => dispatch(fetchFunction(args)))); // NOSONAR
      } else {
        dispatch(fetchFunction(fetchArgs));
      }
    }
  };

  // Use the deletion hook
  const {
    showDeleteModal,
    userToDelete,
    deleteLoading,
    handleDeleteClick,
    handleDeleteConfirm,
    handleDeleteCancel,
  } = useUserDeletion(refreshData);

  useEffect(() => {
    setLoading(true);
    refreshData();
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRowClick = (row) => {
    if (detailRoute) {
      navigate(`${detailRoute}/${row?._id}`);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <UserDataTable
        data={data?.data}
        filteredData={filteredData}
        loading={loading}
        onRowClick={handleRowClick}
        showDeleteModal={showDeleteModal}
        userToDelete={userToDelete}
        deleteLoading={deleteLoading}
        handleDeleteClick={handleDeleteClick}
        handleDeleteConfirm={handleDeleteConfirm}
        handleDeleteCancel={handleDeleteCancel}
        columns={columns}
        title={title}
      />
    </>
  );
};

export default UserManagementWrapper;
